var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOprHrs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8058 8.95327L20.671 11.6663L22.2934 8.93463L21.7179 8.59312L20.989 9.82063C20.6333 4.34604 16.0694 0.000488281 10.5068 0.000488281C4.71338 0.000488281 0.000244141 4.71353 0.000244141 10.5071C0.000244141 16.3005 4.71328 21.0136 10.5068 21.0136C13.8484 21.0136 17.0215 19.4009 18.9957 16.699L18.455 16.3041C16.6066 18.8338 13.6353 20.3442 10.5067 20.3442C5.0823 20.3442 0.669356 15.9313 0.669356 10.5069C0.669356 5.08247 5.0823 0.669519 10.5067 0.669519C15.7571 0.669519 20.0601 4.80465 20.3307 9.98967L19.3571 8.57415L18.8058 8.95327Z",
    fill: "#6DBFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8581 10.2909H18.4977C18.3183 6.16623 15.001 2.84213 10.8788 2.65332V4.27314H10.1385V2.65332C6.02911 2.84172 2.71887 6.14501 2.52098 10.2517H4.12101V10.9924H2.52026C2.69877 15.104 5.99551 18.4211 10.1 18.6286V17.0099H10.8407V18.631C14.9682 18.4616 18.2986 15.1511 18.4974 11.0307H16.8589L16.8588 10.2904L16.8581 10.2909ZM14.9129 11.031H10.1382V5.97278H10.8786V10.2911H14.9128L14.9129 11.031Z",
    fill: "#6DBFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOprHrs);
export default __webpack_public_path__ + "static/media/oprHrs.a802d4543beb0645d4f5720e69f616a1.svg";
export { ForwardRef as ReactComponent };